import { BaseText } from '../model'

export class SearchText extends BaseText {
  name = 'search'
  placeholder = 'Find entities'

  /* 
    We need this because SearchText ignores all properties' changes from outside 
    and extends BaseText with the default name and placeholder values only
  */
  constructor(private args: Partial<SearchText> = {}) {
    super(args)
    return Object.assign(this, args)
  }
}
